const dataButtons = document.querySelectorAll('[data-datalayer]');

function addDataLayers() {

    dataButtons.forEach((button) => {

        // Send Datalayer for buttons pricing page
        if(button.localName == 'form') {
          button.addEventListener('submit', handleClick);
        } else {
          button.addEventListener('click', handleClick);
        }
  });

  function handleClick(evt) {

    const button = evt.target;
    // Get script element connected to correct button (product-overview-contracts.php)
    const data = document.getElementById(button.dataset.datalayer);

    if(data) {
      dataLayer.push(data.innerHTML);
    }
  }
}

if ( dataButtons.length ) {
    addDataLayers();
}
